<template>
  <div class="main">
    <report-top>
      <ly-search slot="search" v-model="searchItem.keyword" @search="search"></ly-search></report-top>
    <selectTool ref="selectTool"><template slot="btn"><Button @click="getSearchItem" type="primary"
          class="chaxun">查询</Button><Button @click="exportAll" type="error" class="chaxun">导出</Button></template>
    </selectTool>

    <Table border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(210)">
      <template #isReturn="{ row }">
        <Tag v-if="row.isReturn" color="blue">反向</Tag>
        <Tag v-else color="cyan">正向</Tag>
      </template>
      <template #state="{ row }">
        <Tag :color="state[row.state].color">{{ state[row.state].name }}</Tag>
      </template>
      <template #type="{ row }">
        <span v-if="row.type === 0">自动检测</span>
        <span v-else-if="row.type === 1">手动记录</span>
        <span v-else-if="row.type === 2">无效记录</span>
      </template>
      <template slot-scope="{ row, index }" slot="markerList">
        <tujing :data="row" title="途经点"></tujing>
      </template>
      <template #startMileage="{ row }"> {{ row.startMileage }}公里 </template>
      <template #endMileage="{ row }">
        <span v-if="row.state === 2">{{ row.endMileage }}公里</span>
        <span v-if="row.state !== 2">未结束</span>
      </template>
      <template #mileage="{ row }">
        <span v-if="row.state === 2">{{ row.mileage }}公里</span>
        <span v-if="row.state !== 2">未结算</span>
      </template>
      <template #duration="{ row }">
        <span v-if="row.state === 2">{{ utils.minTime(row.duration) }}</span>
        <span v-if="row.state !== 2">未结算</span>
      </template>
      <template #startTime="{ row }">
        {{ utils.time(row.startTime) }}
      </template>
      <template #endTime="{ row }">
        <span>{{ row.state === 2 ? utils.time(row.endTime) : "未结束" }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="openDetail(row, index)">查看</Button>
      </template>
    </Table>
    <div id="mypage">
      <Button @click="openFenxi">趟次问题分析</Button>
      <div>
        <Page :current="1" :total="total" :page-size="searchItem.pageSize" :page-size-opts="[10, 50, 100]" show-total
          show-elevator show-sizer @on-change="changePage" @on-page-size-change="pageSizeChange"></Page>
      </div>
    </div>
    <openTangCiFenxi ref="tangCiFenxi" v-if="openTangciFenxi"></openTangCiFenxi>
  </div>
</template>

<script>
var type = {
  0: '自动检测',
  1: '动记录',
  2: '无效记录'
}
import tujing from "./tujing.vue";
import openTangCiFenxi from "./tangcifenxi.vue"
export default {
  components: { tujing,openTangCiFenxi },
  data() {
    return {
      openForm: false,
      openDetailForm: false,
      openTangciFenxi:false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "所属单位",
          key: "groupName",
        },
        {
          title: "设备号",
          key: "deviceNo",
        },
        {
          title: "车牌号",
          key: "carNo",
        },
        {
          title: "驾驶员",
          key: "driverName",
        },
        {
          title: "趟次名称",
          key: "ruleName",
        },
        {
          title: "趟次方向",
          slot: "isReturn",
          width: 100,
        },
        {
          title: "趟次状态",
          slot: "state",
          width: 100,
        },
        {
          title: "趟次途经",
          slot: "markerList",
          width: 100,
        },
        {
          title: "趟次费用",
          key: "cost",
        },
        {
          title: "作业里程",
          slot: "mileage",
        },
        {
          title: "作业时长",
          slot: "duration",
        },
        {
          title: "开始时间",
          slot: "startTime",
          width: 130,
        },
        {
          title: "结束时间",
          slot: "endTime",
          width: 130,
        },
        {
          title: "开始里程",
          slot: "startMileage",
        },
        {
          title: "结束里程",
          slot: "endMileage",
        },
        {
          title: "检测类型",
          key: "type1",
        },
        {
          title: "趟次说明",
          key: "stateDes",
        },
        /* {
          title: "明细",
          slot: "action",
          width: 130,
          align: "center",
          fixed: "right",
        }, */
      ],
      tableData: [],
      item: {
        name: "",
        icon: "car",
        remark: "",
        category: "其他类",
      },
      ruleValidate: {
        name: { required: true, message: "必填" },
        icon: { required: true, message: "必填" },
      },

      searchItem: {
        endTime: 0,
        returnCoord: 2,
        startTime: 0,
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
        deviceIdList: []
      },
      total: 0,

      searchForms: [
        {
          title: "车牌号",
          key: "deviceIdList",
          type: "selectAlotCar",

        },
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          type: "lyyymmdd",
          times: "0,1,2,4",
          formate: 'datetime'
        },
      ],
      state: {
        0: {
          name: "开始",
          color: "default",
        },
        1: {
          name: "途经",
          color: "primary",
        },
        2: {
          name: "结束",
          color: "success",
        },
      },
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.trp + "/times/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        this.tableData = data;
        for (let i = 0; i < data.length; i++) {
          data[i].type1 = type[data[i].type];
        }
        console.log(data);
      });
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    search() {
      this.getList();
    },
    openDetail(row) {
      this.openDetailForm = true;
      this.$refs.detail.reachData(row);
    },
    exportAll() {
      var params = [
        {
          name: "deviceIdList",
          value: this.searchItem.deviceIdList,
        },
        {
          name: "startTime",
          value: this.searchItem.startTime,
        },
        {
          name: "endTime",
          value: this.searchItem.endTime,
        },
      ];
      this.utils.exportData(this.axios.ipPort + "/cloud-car-server-trp/times/export/list", params);
    },
    openFenxi(){
      this.openTangciFenxi=true;
      setTimeout(() => {
        this.$refs.tangCiFenxi.open()
      }, 200);
    }
  },
  mounted() {
    var config = {
      min: 100,
      max: 300,
    };
    this.columns = this.utils.cols([], this.columns, config);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
  },
};
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/tangci/tangcichaxun.vue